<template>
  <div class="enterprise-network_container">
    <div class="enterprise-network_container_title">
      Company Detail Info
    </div>
    <div class="enterprise-network_container_table">
      <el-row class="enterprise-network_mb-40">
        <el-col :span="12">
          <div class="enterprise-network_label">Company Full Name</div>
          <div class="enterprise-network_value save-white-space">{{ formData.companyName || "-" }}</div>
        </el-col>
        <el-col :span="12">
          <div class="enterprise-network_label">Business License Address</div>
          <div class="enterprise-network_value">{{ formData.address || "-" }}</div>
        </el-col>
      </el-row>
      <el-row class="enterprise-network_mb-40">
        <el-col :span="12">
          <div class="enterprise-network_label">Company Full Name (Local Language)</div>
          <div class="enterprise-network_value save-white-space">{{ formData.companyFullName || "-" }}</div>
        </el-col>
        <el-col :span="12">
          <div class="enterprise-network_label">Company Website</div>
          <div class="enterprise-network_value">
            {{ formData.companyWebsite || "-" }}
          </div>
        </el-col>
      </el-row>
      <el-row class="enterprise-network_mb-40">
        <el-col :span="12">
          <div class="enterprise-network_label">Legal Representative</div>
          <div class="enterprise-network_value">
            {{ formData.legalRepresentative || "-" }}
          </div>
        </el-col>
        <el-col :span="12">
          <div class="enterprise-network_label">Organization Code</div>
          <div class="enterprise-network_value">
            {{ formData.organizationCode || "-" }}
          </div>
        </el-col>
      </el-row>
      <el-row class="enterprise-network_mb-40">
        <el-col :span="12">
          <div class="enterprise-network_label">Number of Employees</div>
          <div class="enterprise-network_value">
            {{ formData.peopleNumber || "-" }}
          </div>
        </el-col>
        <el-col :span="12">
          <div class="enterprise-network_label">Date of Foundation</div>
          <div class="enterprise-network_value">
            {{
              formData.setUpDate
                ? dayjs(formData.setUpDate).format("YYYY-MM-DD")
                : "-"
            }}
          </div>
        </el-col>
      </el-row>
      <el-row class="enterprise-network_mb-40">
        <el-col :span="12">
          <div class="enterprise-network_label">
            Business Registration Country/Region
          </div>
          <div class="enterprise-network_value">{{ formData.countryName || "-" }}</div>
        </el-col>
        <el-col :span="12">
          <div class="enterprise-network_label">Authorized Country/Region</div>
          <div class="enterprise-network_value">
            {{ formData.authRegionName || "-" }}
          </div>
        </el-col>
      </el-row>
      <el-row class="enterprise-network_mb-40">
        <el-col :span="12">
          <div class="enterprise-network_label">Ruijie Sales</div>
          <div class="enterprise-network_value">
            {{ formData.ruijieSalesName || "-" }}
          </div>
        </el-col>
        <el-col :span="12">
          <div class="enterprise-network_label">Partner Admin Account</div>
          <div class="enterprise-network_value">
            {{ formData.masterAccount || "-" }}
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "enterpriseNetworkCompanyDetailInfoDetail",
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    }
  },
  methods: {
    dayjs
  }
};
</script>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/components/companyDetailInfo/companyDetailInfoDetail.vue